<template>
  <h3><span style="font-weight: 200"> 'Inner Space' VR &amp; 'Light on Earth' Film</span></h3>
  <h4>Friday, March 15, 6-9pm @ The Bridge Institute, USC, Los Angeles</h4>
  <p>
    Come join us at the
    <a href="https://michelson.usc.edu/">USC Michelson Center for Convergent Bioscience (MCB)</a> to
    explore the 'Inner Space' VR exhibit, and watch a special screening of David Attenborough's
    'Light on Earth', hosted by Regina Wetzer and Steven Haddock. <br />See below for more
    information. This free public science event, hosted by the
    <a href="https://worldbuilding.usc.edu/">World Building Media Lab</a> in partnership with VIZBI
    and the <a href="https://nhm.org/">Natural History Museum of L.A. County</a>.
  </p>
  <a href="https://www.eventbrite.com/e/845912817007" title="Click to register">
    <HeroImage
      hero-image="/Showcase/2024.png"
      credit="World Building Media Lab, Martin Dohrn / Teramata Studios" />
  </a>
  <p>Unfortunately, this event has sold out.</p>
  <RegisterNowWrapper :sold-out="true" />
  <!-- <MaskedVideo img="img/innerspace_mask.png" video="https://drvsqzasuly50.cloudfront.net/loop_4_720.mp4"/> -->
  <p>
    <b>World Building Media Lab's <a href="https://www.exploreinnerspace.org ">Inner Space</a>.</b>
    This immersive virtual reality experience (<a
      href="https://drvsqzasuly50.cloudfront.net/loop_4_720.mp4">
      video </a
    >) is a unique art-science collaboration that delves deep into the submicroscopic world within
    our bodies. Developed by the USC Bridge Institute and the
    <a href="https://worldbuilding.usc.edu/">World Building Media Lab</a>, this VR exhibit will take
    you on a scientifically accurate journey through the molecular processes leading to insulin
    creation in a human pancreatic beta cell.
  </p>
  <p>
    <b>
      David Attenborough's
      <a href="https://www.terramater.at/productions/david-attenboroughs-light-on-earth/">
        Light on Earth
        <!-- prettier-ignore --> </a
      >.
    </b>
    Discover the fascinating world of light-producing organisms in this special screening of David
    Attenborough's
    <a href="https://www.terramater.at/productions/david-attenboroughs-light-on-earth/">
      Light on Earth</a
    >. After the screening, join the panel discussion with the film's scientific advisor
    <a href="https://www.mbari.org/person/steven-haddock/">Steven Haddock</a> (Monterey Bay Aquarium
    Research Institute), and with <a href="https://www.digin-tcn.org/">Regina Wetzer</a> (Natural
    History Museum, L.A. County).
  </p>
  <p>
    This event is co-organized with the
    <a href="https://research.nhm.org/" noreferrer>
      Natural History Museum of Los Angeles County (NHMLAC)</a
    >
    Attendance is free — but you need to
    <a href="https://www.eventbrite.com/e/845912817007">register</a> For any questions, please write
    to <Email to="vizbi-contact" />.
  </p>
  <p>Unfortunately, this event has sold out.</p>
  <!-- <p>
    All VIZBI participants are invited, as are interested scientists and the general public from the local community. .
    Please help spread the word by posting a Flyer ! (<a href="/2024/VIZBI_Showcase_2024_emailable.pdf"
      >emailable PDF</a
    >
    or <a href="/2024/VIZBI_Showcase_2024.pdf">high-quality PDF</a>) To join the Showcase, click the link below to
    sign-up via Eventbrite.
  </p> -->
</template>

<script setup>
import Email from "@/components/Email";
import HeroImage from "@/components/HeroImage";
import RegisterNowWrapper from "@/components/CallToAction/RegisterNowWrapper";
// import ButtonBespoke from "@/components/ButtonBespoke";
// import MaskedVideo from "@/components/MaskedVideo";
//import InnerSpaceMask from ";
//const props = defineProps({devOnly: Boolean}); // hide on vizbi.org
</script>

<style scoped>
h3 {
  display: inline;
}
h4 {
  font-weight: 600;
  font-size: 1rem;
  margin-top: 0.3rem;
}
p button {
  margin-top: 16px;
  margin-bottom: 16px;
}
</style>
